import * as React from 'react';
import { Container, Typography, Grid, Button, Box } from "@mui/material";
import { navigateStripe } from '../utils/utils';

function StripeBuyButton() {

    return (
        <Button
            variant="contained"
            color="primary"
            onClick={navigateStripe}
            sx={{
                textTransform: "none",
                fontSize: "18px",
                fontWeight: "bold",
                padding: "12px 24px",
                borderRadius: "8px",
                backgroundColor: "#4C51BF",
                "&:hover": { backgroundColor: "#3B43A0" },
            }}
        >
            Start Free Trial
        </Button>
    );
}

export default StripeBuyButton;